export const ALLOWED_CITIES = ['Sorocaba', 'Capela do Alto', 'Iperó', 'Boituva', 'Cerquilho', 'Tietê'];

export const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_KEY || '';

export type LatLng = [number, number];

/** Aceita "-23.531, -47.467" ou "-23.531 -47.467" ou "-23.531;-47.467". */
export function parseLatLng(text: string): LatLng | null {
  const match = text.match(/^\s*(-?\d{1,3}(?:[.,]\d+)?)\s*[,;\s]\s*(-?\d{1,3}(?:[.,]\d+)?)\s*$/);
  if (!match) return null;
  const lat = parseFloat(match[1].replace(',', '.'));
  const lng = parseFloat(match[2].replace(',', '.'));
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return [lat, lng];
}

export interface GeocodeHit {
  latlng: LatLng;
  label: string;
}

/** Geocodifica via Google restrito às cidades atendidas. Retorna null se não encontrado. */
export async function searchGoogleAddress(query: string): Promise<GeocodeHit | null> {
  for (const city of ALLOWED_CITIES) {
    const fullQuery = `${query}, ${city}, SP, Brasil`;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      fullQuery
    )}&key=${GOOGLE_MAPS_KEY}&language=pt-BR&region=BR`;
    const res = await fetch(url);
    const data = await res.json();

    if (data.status === 'OK' && data.results?.length > 0) {
      const result = data.results[0];
      const addrComponents = result.address_components || [];
      const resultCity =
        addrComponents.find((c: any) => c.types.includes('administrative_area_level_2'))?.long_name || '';
      const cityMatch = ALLOWED_CITIES.some((c) => resultCity.toLowerCase().includes(c.toLowerCase()));
      if (cityMatch) {
        const { lat, lng } = result.geometry.location;
        return { latlng: [lat, lng], label: result.formatted_address };
      }
    }
  }
  return null;
}
